import angular from "angular";

import BicycleOwnerAuthModuleRouting from "./bicycle-owner-auth.module.routing";

export default angular
  .module("vt-bicycle-owner-auth", [])
  .config(BicycleOwnerAuthModuleRouting);
